import React, { useContext, useState } from "react";
import UserInfo from "../../../../components/SVGComponents/UserInfo";
import { useTranslation } from "react-i18next";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ViewportContext from "../../../../context/studyviewer/ViewportContext";
import { isMobile } from "react-device-detect";
import MobileBottomSheet from "../Toolbar/MobileBottomSheet"; // Import the bottom sheet component
import MobileOverlayBottomSheet from "./MobileOverlayBottomSheet"; // Import the bottom sheet component
import userContext from "../../../../context/users/UserContext";
import { USERTYPES } from "../../../../constants/Constants";
import { getEnv } from '../../../../helpers/EnvHelper';


const MobileOverlay = ({ viewportData }) => {
  const { t } = useTranslation();
  const { getConsistentDateFormat } = useContext(studyReportContext);
  const { isUserInfoClicked, setIsUserInfoClicked } =
   useContext(ViewportContext);

  const {roles, qcOutsourceLogin} = useContext(userContext);
  
  // Local state for that specific viewport
  // const [isUserInfoClicked, setIsUserInfoClicked] = useState(false);
  const [isUserInfoVisible, setIsUserInfoVisible] = useState(false); 
  
  const handleUserInfoClick = () => {
  if (isMobile) {
    setIsUserInfoClicked(!isUserInfoClicked);
  } else {
    // Toggle local state for the selected viewport
    setIsUserInfoVisible(!isUserInfoVisible);
  }
};

  return (
    <>
      <div
        className="viewport-overlay-mobile-viewer"
        onClick={handleUserInfoClick}
      >
        <UserInfo
          color={isUserInfoClicked ? "#2F80ED" : "rgba(255, 255, 255, 0.42)"}
        />
      </div>
      {!isMobile && isUserInfoVisible  && (
        <div className="viewport-overlay-mobile-popup react-scroll">
          <div style={{ lineHeight: "12px" }}>
            <span className="viewport-overlay-mobile-value">
              {viewportData?.studyDescription || "-"}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-mobile-key">
              {t("viewer.overlay.study-date")}:{" "}
            </span>
            <span className="viewport-overlay-mobile-value">
              {getConsistentDateFormat(viewportData?.studyDate)}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-mobile-key">
              {t("viewer.overlay.patient-id")}:{" "}
            </span>
            <span className="viewport-overlay-mobile-value">
              {viewportData?.patientId}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-mobile-key">
              {t("viewer.overlay.patient-name")}:{" "}
            </span>
            <span className="viewport-overlay-mobile-value">
              {viewportData?.patientName}
            </span>
          </div>
          {((roles[0] == USERTYPES.FIRMADMIN || (roles[0] == USERTYPES.SUPERVISOR && !qcOutsourceLogin)) && 
            (getEnv("REACT_APP_VDC_PLATFORM") == "false" || getEnv("REACT_APP_VDC_PLATFORM") == false) &&
            (getEnv("REACT_APP_BVP_PLATFORM") == "false" || getEnv("REACT_APP_BVP_PLATFORM") == false)) && (
                <div style={{ lineHeight: "12px", marginTop: "5px" }}>
                  <span className="viewport-overlay-mobile-key">
                    {t("viewer.overlay.client-name")}:{" "}
                  </span>
                  <span className="viewport-overlay-mobile-value">
                    {viewportData?.clientName || '-'}
                  </span>
                </div>
            )}
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-mobile-key">
              {t("viewer.overlay.gender")}:{" "}
            </span>
            <span className="viewport-overlay-mobile-value">
              {viewportData?.patientSex === "M"
                ? t("viewer.overlay.male")
                : t("viewer.overlay.female")}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-mobile-key">
              {t("viewer.overlay.age")}:{" "}
            </span>
            <span className="viewport-overlay-mobile-value">
              {viewportData?.patientAge?.replace(/^0|-$/, "")}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-key">
              {t("viewer.overlay.series")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {viewportData?.series}
            </span>
          </div>
          <div style={{ lineHeight: "12px", marginTop: "5px" }}>
            <span className="viewport-overlay-key">
              {t("viewer.overlay.modality")}:{" "}
            </span>
            <span className="viewport-overlay-value">
              {viewportData?.seriesModality ?? viewportData?.modality}
            </span>
          </div>
        </div>
      )}
      {/* {isMobile && isUserInfoClicked && <MobileBottomSheet viewportData={viewportData} />} */}
      {isMobile && isUserInfoClicked && <MobileOverlayBottomSheet viewportData={viewportData} />}

    </>
  );
};

export default MobileOverlay;
